import { useRef, useEffect, useState } from 'react';
import { IVimeoPlayerProps } from './interface';

// Vimeo Player
import Vimeo from '@vimeo/player';

// Utils
import classNames from 'classnames';

import styles from './VimeoPlayer.module.scss';

const VimeoPlayer = (props: IVimeoPlayerProps) => {
    const {
        className,
        video,
        playOnHover,
        options,
        onReady,
        onPlay,
        onTimeUpdate,
        onPause,
        onEnd,
        onLoaded,
        currentTime = false,
        thumbnail
    } = props;
    const playerRef = useRef<HTMLDivElement>(null);

    const [myPlayer, setMyPlayer] = useState<any>();
    const [displayThumbnail, setDisplayThumbnail] = useState(false);

    useEffect(() => {
        const player = new Vimeo(playerRef.current!, {
            url: `https://player.vimeo.com/video/${video}?background=1/`,
            pip: false,
            ...options
        });

        setMyPlayer(player);

        if (playOnHover) {
            const mouseenter = () => {
                player.play();
            };

            const mouseleave = () => {
                player.pause();
            };

            playerRef.current?.addEventListener('mouseenter', mouseenter);
            playerRef.current?.addEventListener('mouseleave', mouseleave);

            return () => {
                playerRef.current?.removeEventListener('mouseenter', mouseenter);
                playerRef.current?.removeEventListener('mouseleave', mouseleave);
            };
        }

        if (onLoaded) {
            player.on('loaded', onLoaded);
        }

        if (onReady) {
            player.ready().then(onReady);
        }

        if (onPlay) {
            player.on('play', onPlay);
        }

        if (onTimeUpdate) {
            player.on('timeupdate', (progress) => onTimeUpdate(progress));
        }

        if (onPause) {
            player.on('pause', onPause);
        }

        if (onEnd) {
            player.on('ended', onEnd);
        }

        return () => {
            player.destroy();
        };
    }, [video]);

    useEffect(() => {
        if (myPlayer) {
            myPlayer.setVolume(+!Boolean(options?.muted));
        }
    }, [options?.muted]);

    useEffect(() => {
        if (currentTime) {
            myPlayer?.setCurrentTime(0);
        }
    }, [currentTime]);

    return (
        <div className={classNames('vimeo-video', styles.player, className)} ref={playerRef}>
            {thumbnail ? <img src={thumbnail} alt={''} className="thumbnail" /> : null}
        </div>
    );
};

export default VimeoPlayer;
